import { lazy } from "react";

export const EmployeeHomePage = lazy(() =>
  import("../views/employee/home/HomePage").then((m) => ({
    default: m.AdminHomePage,
  })),
);

export const EmployeeUsersAndOrgPage = lazy(() =>
  import("../views/employee/admin/users/UsersAndOrgPage").then((m) => ({
    default: m.UsersAndOrgPage,
  })),
);

export const EmployeeManageScopePage = lazy(() =>
  import("../views/employee/manage/MyScopePage").then((m) => ({
    default: m.MyScopePage,
  })),
);

export const EmployeeReportsPage = lazy(() =>
  import("../views/employee/manage/reports/ReportsPage").then((m) => ({
    default: m.ReportsPage,
  })),
);

export const EmployeeMessageReportsRedirect = lazy(() =>
  import("../views/employee/manage/reports/ReportsPage").then((m) => ({
    default: m.MessageReportsRedirect,
  })),
);

export const EmployeeLibraryAdminPage = lazy(() =>
  import("../views/employee/library/LibraryAdminPage").then((m) => ({
    default: m.LibraryAdminPage,
  })),
);
export const EmployeeGiftcardsAdminPage = lazy(() =>
  import("../views/employee/giftcards/GiftcardsAdminPage").then((m) => ({
    default: m.GiftcardsAdminPage,
  })),
);
export const EmployeeRecognitionAdminPage = lazy(() =>
  import("../views/employee/recognition/RecognitionAdminPage").then((m) => ({
    default: m.RecognitionAdminPage,
  })),
);
export const EmployeeManageRewardsPage = lazy(() =>
  import("../views/employee/manage/rewards/ManageRewardsPage").then((m) => ({
    default: m.ManageRewardsPage,
  })),
);
export const EmployeeManageBroadcastsPage = lazy(() =>
  import("../views/employee/manage/broadcasts/ManageBroadcastsPage").then((m) => ({
    default: m.ManageBroadcastsPage,
  })),
);
export const EmployeeBroadcastComposerPage = lazy(() =>
  import("../views/employee/manage/broadcasts/compose/BroadcastComposerPage").then((m) => ({
    default: m.BroadcastComposerPage,
  })),
);
export const EmployeeBroadcastReportPage = lazy(() =>
  import("../views/employee/manage/broadcasts/report/BroadcastReportPage").then((m) => ({
    default: m.BroadcastReportPage,
  })),
);
export const EmployeeManageAcksPage = lazy(() =>
  import("../views/employee/library/ManageAcksPage").then((m) => ({
    default: m.ManageAcksPage,
  })),
);
export const EmployeeManageContentPage = lazy(() =>
  import("../views/employee/manage/content/ManageContentPage").then((m) => ({
    default: m.ManageContentPage,
  })),
);

export const EmployeeAnswerSurveyPage = lazy(() =>
  import("../views/employee/my/surveys/AnswerSurveyPage").then((m) => ({
    default: m.AnswerSurveyPage,
  })),
);

export const EmployeeManageSurveysPage = lazy(() =>
  import("../views/employee/manage/surveys/ManageSurveysPage").then((m) => ({
    default: m.ManageSurveysPage,
  })),
);
export const EmployeeMyPostPage = lazy(() =>
  import("../views/employee/feed/PostPage").then((m) => ({ default: m.PostPage })),
);
export const EmployeeMyHomePage = lazy(() =>
  import("../views/employee/home/HomePage").then((m) => ({ default: m.HomePage })),
);
export const EmployeeMyMessagesPage = lazy(() =>
  import("../views/employee/my/messages/MessagesPage").then((m) => ({ default: m.MessagesPage })),
);
export const EmployeeMyDirectoryPage = lazy(() =>
  import("../views/employee/directory/DirectoryPage").then((m) => ({ default: m.DirectoryPage })),
);
export const EmployeeLeaderboardPage = lazy(() =>
  import("../views/employee/leaderboard/LeaderboardPage").then((m) => ({
    default: m.LeaderboardPage,
  })),
);
export const EmployeeMySurveysPage = lazy(() =>
  import("../views/employee/my/surveys/MySurveysPage").then((m) => ({
    default: m.MySurveysPage,
  })),
);
export const EmployeeMyRewardsPage = lazy(() =>
  import("../views/employee/rewards/RewardsPage").then((m) => ({ default: m.RewardsPage })),
);
export const EmployeeMyResourcesPage = lazy(() =>
  import("../views/employee/library/MyResourcesPage").then((m) => ({ default: m.MyResourcesPage })),
);
export const EmployeeMyProfilePage = lazy(() =>
  import("../views/employee/my/MyProfilePage").then((m) => ({ default: m.MyProfilePage })),
);

export const EmployeeMyRequestsPage = lazy(() =>
  import("../views/employee/requests/MyRequestsPage").then((m) => ({ default: m.MyRequestsPage })),
);

// The Service Desk customer portal pages, shown inside skyEmployee.
export const EmployeeNewRequestPage = lazy(() =>
  import("../views/employee/requests/ServiceDeskPages").then((m) => ({
    default: m.EmployeeNewRequestPage,
  })),
);
export const EmployeeRequestPortalPage = lazy(() =>
  import("../views/employee/requests/ServiceDeskPages").then((m) => ({
    default: m.EmployeeRequestPortalPage,
  })),
);
export const EmployeeRequestDetailPage = lazy(() =>
  import("../views/employee/requests/ServiceDeskPages").then((m) => ({
    default: m.EmployeeRequestDetailPage,
  })),
);
export const EmployeeRequestHelpPage = lazy(() =>
  import("../views/employee/requests/ServiceDeskPages").then((m) => ({
    default: m.EmployeeRequestHelpPage,
  })),
);

export const EmployeeNotificationSettingsPage = lazy(() =>
  import("../views/employee/notifications/NotificationSettingsPage").then((m) => ({
    default: m.NotificationSettingsPage,
  })),
);

export const EmployeeSettingsPage = lazy(() =>
  import("../views/employee/admin/settings/EmployeeSettingsPage").then((m) => ({
    default: m.EmployeeSettingsPage,
  })),
);

export const EmployeeMessagingSettingsPage = lazy(() =>
  import("../views/employee/admin/messaging/MessagingSettingsPage").then((m) => ({
    default: m.MessagingSettingsPage,
  })),
);
